<div *ngIf="isMDD; else NormalDD">
  <div class="fieldset-wrapper" [ngClass]="
      (questions?.mandatory && (isMandatoryUpfront || questions?.isMandatoryStar)) ||
      (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid)
        ? 'isMandatory'
        : ''
    " style="overflow: visible">
    <div *ngIf="questions?.group_no == 0 && questions?.QuestionImageAndMedia_1 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_1"
        [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>
    <div>
      <label class="question-option-wrapper subqtn" for="lbltitle_L{{ questions?.UniqueNumber }}" *ngIf="
          (questions?.pipingQuationTitle != '' && questions.piping) ||
          (questions?.qtitle != '' && !questions.piping) ||
          isDisplaySubQno ||
          ((questions?.mandatory || isAnySubQMandatory) && isMandatoryUpfront)
        ">
        <span *ngIf="isPreview && (questions?.population_type == 2 || questions?.population_type == 5)"
          class="hidden-question-tooltip-icon hdn-mdd" appTooltip [dataContext]="''" [IsButtonPanel]="false"
          IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0"></span>
        <span *ngIf="isDisplayQno" class="question-no"><strong>{{ questions?.qno }}.</strong></span>
        <span *ngIf="isDisplaySubQno" class="question-no"><strong>{{ questions?.subQnoinChar }}</strong></span>
        <span *ngIf="questions.piping && !isGrid" [ngClass]="{
            'question-text 1': questions.isOverAllStyleApplied,
            'question-text-nb': !questions.isOverAllStyleApplied,
            'mw-sub-question-text': isGrid,
            'no-subQno 1': !isDisplaySubQno
          }" id="lbltitle_L{{ questions?.UniqueNumber }}">
          <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
          <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
            [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
            <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (questions?.population_type== 4 || questions?.population_type == 5)"></span> 
        </span>
        <span *ngIf="!questions.piping || isGrid" [ngClass]="{
            'question-text 2': questions.isOverAllStyleApplied,
            'question-text-nb': !questions.isOverAllStyleApplied,
            'mw-sub-question-text': isGrid,
            'no-subQno 2': !isDisplaySubQno
          }" id="lbltitle_L{{ questions?.UniqueNumber }}">
          <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
          <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
            [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
            <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (questions?.population_type== 4 || questions?.population_type == 5)"></span>
        </span>
      </label>

      <div *ngIf="questions?.group_no == 0 && questions?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
        <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_2"
          [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
        </app-question-image-and-media>
      </div>
      <div class="answer-option-wrapper dd-box" [attr.data-ans-image]="answerImagesLength" [ngClass]="{
          relativeMdd:
            !isDisplaySubQno &&
            !isDisplayQno &&
            questions?.qtitle == '' && questions?.pipingQuationTitle == undefined
        }">
        <div *ngIf="questions?.population_type != 3; else PreReadPopulation">
          <div *ngIf="questions?.DispAnsCol > 1 || questions?.qtype == 'HR'; else SingleColumnCode"></div>
          <ng-template #SingleColumnCode>
            <!-- Less Than 10 -->
            <div class="custom-select-wrapper" *ngIf="MDDdropDownCount > questions?.Answers.length || isNonSearchable">
              <div class="arr">
                <div class="arr-symbol"></div>
              </div>
              <select (change)="SelectedValue($event, false); nextQuestion($event.target)"
                [(ngModel)]="questions.selectAnsValue" [attr.aria-label]="questions?.qtitle"
                [attr.aria-required]="isAriaRequired">
                <option [innerHTML]="DropDown | headerFooterHtml" [value]="-1" selected></option>
                <option *ngFor="let answers of questions?.Answers" [disabled]="answers?.isQuotaDisable"
                  [hidden]="answers?.isHide || answers?.isADLHide" [value]="answers.value_id">
                  <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                </option>
              </select>
            </div>
            <!-- More Than 10 -->
            <div class="custom-select-wrapper drill-down-search"
              *ngIf="questions?.Answers.length >= MDDdropDownCount && !isNonSearchable">
              <div class="arr" (click)="showDDList($event)">
                <div class="arr-symbol"></div>
              </div>
              <ng-template [ngIf]="isMobile && !isIEOrEdge">
                <input type="text" class="drill-down-input" placeholder="{{ surveyMessages.Search }}"
                  (input)="filterDDSearch($event)" (click)="filterDDSearch($event)" (change)="filterDDSearch($event)"
                  (blur)="setDDListItem($event, questions)" (focus)="setPrevValue($event)"
                  [(ngModel)]="questions.AnswerText" aria-label="Search" [attr.aria-required]="isAriaRequired"
                  role="combobox" aria-haspopup="listbox" [attr.aria-owns]="'dropdown_list_' + questions.UniqueNumber"
                  aria-expanded="false" (keydown.esc)="closeDDList($event)"
                  (keydown.alt.arrowdown)="showDDList($event)" />
              </ng-template>
              <ng-template [ngIf]="!isMobile || (isIEOrEdge && isMobile)">
                <input type="text" class="drill-down-input" placeholder="{{ surveyMessages.Search }}"
                  (keydown)="filterDDSearch($event)" (click)="filterDDSearch($event)" (change)="filterDDSearch($event)"
                  (blur)="setDDListItem($event, questions)" (focus)="setPrevValue($event)"
                  [(ngModel)]="questions.AnswerText" aria-label="Search" [attr.aria-required]="isAriaRequired"
                  role="combobox" aria-haspopup="listbox" [attr.aria-owns]="'dropdown_list_' + questions.UniqueNumber"
                  aria-expanded="false" (keydown.esc)="closeDDList($event)"
                  (keydown.alt.arrowdown)="showDDList($event)" />
              </ng-template>
              <div class="drill-down-list" [ngStyle]="{ 'max-height': isMDD ? '70px' : '300px' }"
                style="overflow: auto; z-index: 1000" role="listbox"
                [attr.aria-labelledby]="'lbltitle_L' + questions?.UniqueNumber">
                <div class="drill-down-list-item" *ngFor="let answers of questions?.Answers"
                  [attr.list-value]="answers.value_id" [ngClass]="{
                    quotaDisable: answers?.isQuotaDisable,
                    ddItemHidden: answers?.isHide
                  }" (mousedown)="selectDDListItem($event, questions)" [attr.ogListValue]="answers.value_text"
                  role="option">
                  {{ answers.value_text }}
                </div>
              </div>
              <select (change)="SelectedValue($event, true)" [(ngModel)]="questions.selectAnsValue"
                [attr.aria-label]="questions?.qtitle" [attr.aria-required]="isAriaRequired" tabindex="-1"
                aria-hidden="true">
                <option [innerHTML]="DropDown | headerFooterHtml" [value]="-1" selected></option>
                <option *ngFor="let answers of questions?.Answers" [disabled]="answers?.isQuotaDisable"
                  [hidden]="answers?.isHide || answers?.isADLHide" [value]="answers.value_id">
                  <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                </option>
              </select>
            </div>
            <div class="drill-down-list-itemMessage_{{
                questions?.UniqueNumber
              }} drill-down-list-itemMessage">
              <span>{{ Nomatchfound }}</span>
            </div>
            <div *ngIf="questions?.isOtherAnswer" class="other-textans dropdown 1">
              <label *ngIf="questions.other_text" class="other-opt-text"
                for="{{ questions?.UniqueNumber }}_txt_other">{{ questions.other_text }}</label>
              <input type="text" [hidden]="!questions?.isOtherAnswer" [style.width]="questions?.twidth + '%'"
                class="ansopt-textbox" maxlength="3500" id="{{ questions?.UniqueNumber }}_txt_other"
                (blur)="onBlurMethod()" [(ngModel)]="questions.otherAnswer" aria-label="textbox" />
            </div>
          </ng-template>
        </div>
        <ng-template #PreReadPopulation>
          <div class="answer-option DropDown-read-only radio" *ngFor="let answers of questions?.Answers; let i = index"
            [ngClass]="
              answers?.hasImage && answers?.AnswerImages.length == 1
                ? 'single-ans-image'
                : answers?.hasImage && answers?.AnswerImages.length == 2
                  ? 'multi-ans-image'
                  : ''
            ">
            <div [hidden]="answers?.isHide || answers?.isADLHide">
              <div *ngIf="questions?.selectAnsValue == answers?.value_id">
                <label for="lbl_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_L_{{
                    answers?.value_id
                  }}_ID">
                  <span class="read-only answer-text">{{ answers.value_text }}</span>
                </label>
                <div *ngIf="questions?.isOtherAnswer" class="other-textans dropdown 2">
                  <label *ngIf="questions.other_text" class="other-opt-text"
                    for="{{ questions?.UniqueNumber }}_txt_other">{{ questions.other_text }}</label>
                  <input type="text" [hidden]="!questions?.isOtherAnswer" [style.width]="questions?.twidth + '%'"
                    class="ansopt-textbox" maxlength="3500" id="{{ questions?.UniqueNumber }}_txt_other"
                    (blur)="onBlurMethod()" [(ngModel)]="questions.otherAnswer" aria-label="textbox" />
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-container *ngIf="
            isNewParticipation &&
            (surveyFormat == 1 || surveyFormat == 2) &&
            isNewParticipationButton
          ">
          <div class="ques-response-btn-div">
            <button [hidden]="true" type="button" class="ques-response-btn"
              (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
              (click)="gotoNextQuestion(questions, $event.target)">
              {{ newParticipationBtnText }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #NormalDD>
  <div class="fieldset-wrapper" [ngClass]="
      (questions?.mandatory && (isMandatoryUpfront || questions?.isMandatoryStar)) ||
      (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid)
        ? 'isMandatory'
        : ''
    " style="overflow: visible">
    <div *ngIf="questions?.group_no == 0 && questions?.QuestionImageAndMedia_1 != null" class="questionImageWrapper"
      [ngClass]="{ 'question-border': !isMobile }">
      <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_1"
        [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>
    <fieldset [attr.aria-required]="isAriaRequired">
      <legend class="dd-legend sr-only">
        <span class="screen-read-only" *ngIf="(questions?.mandatory && (isMandatoryUpfront || questions?.isMandatoryStar)) ||
              (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid)">This Question is Required</span>
      </legend>
      <div class="question-option-wrapper" [ngClass]="{
          'mobile-sub-question': isGrid,
          'question-border': questions?.QuestionImageAndMedia_1 == null && !isMobile && !isGrid
        }" *ngIf="!isDemographics">
        <span *ngIf="isPreview && (questions?.population_type == 2 || questions?.population_type == 5)"
          class="hidden-question-tooltip-icon" appTooltip [dataContext]="''" [IsButtonPanel]="false"
          IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0">
        </span>
        <span *ngIf="isDisplayQno" class="question-no"><strong>{{ questions?.qno }}.</strong></span>
        <span *ngIf="questions.piping && !isGrid" [ngClass]="{
            'question-text 3': questions.isOverAllStyleApplied,
            'question-text-nb': !questions.isOverAllStyleApplied,
            'mw-sub-question-text': isGrid,
            'no-Qno': !isDisplayQno
          }" id="lbltitle_L{{ questions?.UniqueNumber }}">
          <span *ngIf="isDisplaySubQno; else NonDisplaySubQno" class="question-no"><strong>{{ questions?.subQnoinChar
              }}</strong>
          </span>
          <ng-template #NonDisplaySubQno>
            <span style="display: none"></span>
          </ng-template>
          <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
          <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
            [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
            <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (questions?.population_type== 4 || questions?.population_type == 5)"></span>
        </span>
        <span *ngIf="!questions.piping || isGrid" [ngClass]="{
            'question-text 44': questions.isOverAllStyleApplied,
            'question-text-nb': !questions.isOverAllStyleApplied,
            'mw-sub-question-text': isGrid,
            'no-Qno': !isDisplayQno && !isGrid,
            'no-subQno 2': !isDisplaySubQno
          }" id="lbltitle_L{{ questions?.UniqueNumber }}">
          <span *ngIf="!isDemographics && isDisplaySubQno; else NonDisplaySubQno" style="display: inline-block"
            [innerHTML]="questions?.subQnoinChar | headerFooterHtml"></span>
          <ng-template #NonDisplaySubQno>
            <span class="no-display" style="display: none"></span>
          </ng-template>
          <ng-container *ngIf="questions.piping && isGrid; else NormalTitle">
            <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
          </ng-container>
          <ng-template #NormalTitle>
            <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
          </ng-template>
          <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
            [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
            <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (questions?.population_type== 4 || questions?.population_type == 5)"></span>
          <div *ngIf="
              questions?.hasMedia &&
              !isOtherControl &&
              questions?.MediaText != null &&
              questions?.MediaText != ''
            " class="question-media-text">
            <span>[{{ questions?.MediaText }}]</span>
          </div>
        </span>
        <span *ngIf="isAriaRequired && (isMobile || isGrid)" class="screen-reader-only">This Question is Required</span>
      </div>

      <div class="question-option-wrapper" *ngIf="isDemographics">
        <span *ngIf="isPreview && (questions?.population_type == 2 || questions?.population_type == 5)"
          class="hidden-question-tooltip-icon hdn-demo" appTooltip [dataContext]="''" [IsButtonPanel]="false"
          IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0"></span>
        <span *ngIf="isDisplayQno" class="question-no"><strong>{{ questions?.qno }}.</strong></span>
        <span *ngIf="isDisplaySubQno" class="question-no"><strong>{{ questions?.subQnoinChar }}</strong></span>
        <span *ngIf="questions.piping && !isGrid" [ngClass]="{
            'question-text 5': questions.isOverAllStyleApplied,
            'question-text-nb': !questions.isOverAllStyleApplied,
            'mw-sub-question-text': isGrid,
            'no-subQno 4': !isDisplaySubQno
          }" id="lbltitle_L{{ questions?.UniqueNumber }}">
          <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
          <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
            [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
            <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (questions?.population_type== 4 || questions?.population_type == 5)"></span>
          <span *ngIf="isAriaRequired" class="screen-reader-only">This Question is Required</span>
        </span>
        <span *ngIf="!questions.piping || isGrid" [ngClass]="{
            'question-text 6': questions.isOverAllStyleApplied,
            'question-text-nb': !questions.isOverAllStyleApplied,
            'mw-sub-question-text': isGrid,
            'no-subQno': !isDisplaySubQno
          }" id="lbltitle_L{{ questions?.UniqueNumber }}">
          <span *ngIf="!isDemographics" [innerHTML]="questions?.subQnoinChar | headerFooterHtml"></span>
          <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
          <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
            [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
            <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (questions?.population_type== 4 || questions?.population_type == 5)"></span>
          <div *ngIf="
              questions?.hasMedia &&
              !isOtherControl &&
              questions?.MediaText != null &&
              questions?.MediaText != ''
            " class="question-media-text">
            <span>[{{ questions?.MediaText }}]</span>
          </div>
          <span *ngIf="isAriaRequired" class="screen-reader-only">This Question is Required</span>
        </span>
      </div>

      <div *ngIf="questions?.group_no == 0 && questions?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
        <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_2"
          [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
        </app-question-image-and-media>
      </div>
      <div class="answer-option-wrapper dd-box" [attr.data-ans-image]="answerImagesLength">
        <div *ngIf="questions?.population_type != 3; else PreReadPopulation">
          <div *ngIf="questions?.DispAnsCol > 1 || questions?.qtype == 'HR'; else SingleColumnCode"></div>
          <ng-template #SingleColumnCode>
            <!-- Less Than 10 -->
            <div class="custom-select-wrapper" *ngIf="dropDownCount > questions?.Answers.length || isNonSearchable">
              <div class="arr">
                <div class="arr-symbol"></div>
              </div>
              <select (change)="SelectedValue($event, false); nextQuestion($event.target)"
                [(ngModel)]="questions.selectAnsValue" [attr.aria-label]="questions?.qtitle"
                [disabled]="questions?.IsDisabled">
                <option [innerHTML]="DropDown | headerFooterHtml" [value]="-1" selected></option>
                <option *ngFor="let answers of questions?.Answers | callBack: getHiddenAnswer"
                  [disabled]="answers?.isQuotaDisable" [hidden]="answers?.isHide || answers?.isADLHide"
                  [value]="answers.value_id" [innerHTML]="answers.value_text | headerFooterHtml"></option>
              </select>
            </div>
            <!-- More Than 10 -->
            <div class="custom-select-wrapper drill-down-search"
              *ngIf="questions?.Answers.length >= dropDownCount && !isNonSearchable">
              <div class="arr" (click)="showDDList($event)">
                <div class="arr-symbol"></div>
              </div>

              <ng-template [ngIf]="isMobile && !isIEOrEdge">
                <input type="text" class="drill-down-input" placeholder="{{ surveyMessages.Search }}"
                  (input)="filterDDSearch($event)" (click)="filterDDSearch($event)" (change)="filterDDSearch($event)"
                  (blur)="setDDListItem($event, questions)" (focus)="setPrevValue($event)"
                  [(ngModel)]="questions.AnswerText" aria-label="Search" role="combobox" aria-haspopup="true"
                  [attr.aria-owns]="'dropdown_list_' + questions.UniqueNumber" aria-expanded="false"
                  (keydown.esc)="closeDDList($event)" (keydown.alt.arrowdown)="showDDList($event)" />
              </ng-template>
              <ng-template [ngIf]="!isMobile || (isIEOrEdge && isMobile)">
                <input type="text" class="drill-down-input" placeholder="{{ surveyMessages.Search }}"
                  (keydown)="filterDDSearch($event)" (click)="filterDDSearch($event)" (change)="filterDDSearch($event)"
                  (blur)="setDDListItem($event, questions)" (focus)="setPrevValue($event)"
                  [(ngModel)]="questions.AnswerText" aria-label="Search" role="combobox" aria-haspopup="true"
                  [attr.aria-owns]="'dropdown_list_' + questions.UniqueNumber" aria-expanded="false"
                  (keydown.esc)="closeDDList($event)" (keydown.alt.arrowdown)="showDDList($event)" />
              </ng-template>

              <div id="dropdown_list_{{ questions.UniqueNumber }}" class="drill-down-list"
                style="max-height: 300px; overflow: auto; z-index: 1000" role="listbox"
                [attr.aria-labelledby]="'lbltitle_L' + questions?.UniqueNumber">
                <div class="drill-down-list-item" *ngFor="let answers of questions?.Answers"
                  [attr.list-value]="answers.value_id" [ngClass]="{
                    quotaDisable: answers?.isQuotaDisable,
                    ddItemHidden: answers?.isHide || answers?.isADLHide
                  }" (mousedown)="selectDDListItem($event, questions)" [attr.ogListValue]="answers.value_text"
                  role="option">
                  {{ answers.value_text }}
                </div>
              </div>

              <select (change)="SelectedValue($event, false)" [(ngModel)]="questions.selectAnsValue"
                [attr.aria-label]="questions?.qtitle" tabindex="-1" aria-hidden="true">
                <option [innerHTML]="DropDown | headerFooterHtml" [value]="-1" selected></option>
                <option *ngFor="let answers of questions?.Answers" [disabled]="answers?.isQuotaDisable"
                  [hidden]="answers?.isHide || answers?.isADLHide" [value]="answers.value_id">
                  <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                </option>
              </select>
            </div>
            <div class="drill-down-list-itemMessage_{{
                questions?.UniqueNumber
              }} drill-down-list-itemMessage">
              <span>{{ Nomatchfound }}</span>
            </div>
            <!-- Other Answer TextBox -->
            <div *ngIf="!this.isDemographics && !isGrid" [hidden]="!questions?.isOtherAnswer"
              class="other-textans dropdown 3">
              <label *ngIf="questions.other_text" class="other-opt-text"
                for="{{ questions?.UniqueNumber }}_txt_other">{{ questions.other_text }}</label>
              <input type="text" [hidden]="!questions?.isOtherAnswer" [style.width]="questions?.twidth + '%'"
                class="ansopt-textbox" maxlength="3500" id="{{ questions?.UniqueNumber }}_txt_other"
                (blur)="onBlurMethod()" [(ngModel)]="questions.otherAnswer" aria-label="textbox" />
            </div>
          </ng-template>
        </div>
        <ng-template #PreReadPopulation>
          <div class="answer-option DropDown-read-only radio">
            <div>
              <span class="answer-text">{{ questions.PrePopText }}</span>

              <div *ngIf="questions?.isOtherAnswer">
                <label for="lbl_Q{{ questions?.qno }}_{{ questions?.UniqueNumber }}_L_ID">
                  <span class="radio-btn structure"></span>
                </label>
                <div *ngIf="questions?.isOtherAnswer" class="other-textans dropdown 4">
                  <label *ngIf="questions.other_text" class="other-opt-text"
                    for="{{ questions?.UniqueNumber }}_txt_other">{{ questions.other_text }}</label>
                  <input type="text" [hidden]="!questions?.isOtherAnswer" [style.width]="questions?.twidth + '%'"
                    class="ansopt-textbox" maxlength="3500" id="{{ questions?.UniqueNumber }}_txt_other"
                    [(ngModel)]="questions.otherAnswer" (blur)="onBlurMethod()" aria-label="textbox" />
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-container *ngIf="
            isNewParticipation && (surveyFormat == 1 || surveyFormat == 2) && !this.isDemographics
          ">
          <div class="ques-response-btn-div" *ngIf="showNewParticipationButton || isOtherQuestion">
            <button *ngIf="isAnsChange" type="button" class="ques-response-btn"
              (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
              (click)="gotoNextQuestion(questions, $event.target)">
              {{ newParticipationBtnText }}
            </button>
          </div>
          <div class="ques-response-btn-div" *ngIf="!showNewParticipationButton && !isOtherQuestion">
            <button *ngIf="isAnsChange" type="button" class="ques-response-btn"
              (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
              (click)="gotoNextQuestion(questions, $event.target)">
              {{ newParticipationBtnText }}
            </button>
          </div>
        </ng-container>
      </div>
    </fieldset>
  </div>
</ng-template>